var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83366 6.33317H6.33366V6.83317V10.9998C6.33366 11.182 6.18252 11.3332 6.00033 11.3332C5.81813 11.3332 5.66699 11.182 5.66699 10.9998V6.83317V6.33317H5.16699H1.00033C0.818135 6.33317 0.666992 6.18203 0.666992 5.99984C0.666992 5.81765 0.818134 5.6665 1.00033 5.6665H5.16699H5.66699V5.1665V0.999837C5.66699 0.817646 5.81813 0.666504 6.00033 0.666504C6.18252 0.666504 6.33366 0.817646 6.33366 0.999837V5.1665V5.6665H6.83366H11.0003C11.1825 5.6665 11.3337 5.81765 11.3337 5.99984C11.3337 6.18203 11.1825 6.33317 11.0003 6.33317H6.83366Z",
    fill: "#323232",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhite);
export default __webpack_public_path__ + "static/media/plus_white.3767ca66c04393a2a98972e4fecc60ef.svg";
export { ForwardRef as ReactComponent };